import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "container-fluid",
  style: {"margin-top":"80px","padding-top":"40px"}
}
const _hoisted_2 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_3 = { class: "toolbar" }
const _hoisted_4 = {
  class: "btn-group",
  role: "group"
}
const _hoisted_5 = { class: "btn btn-outline-secondary" }
const _hoisted_6 = { class: "table table-bordered table-hover" }
const _hoisted_7 = { class: "dropdown" }
const _hoisted_8 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]

import { computed, watch, onMounted, shallowReactive, type Ref } from 'vue'
    import { useRoute } from 'vue-router'

    import { strCompareLowerCase, toStringSmartly } from '@common/Common'
    import { guid } from '@common/Guid'

    import CorporateNavigation from '@common/Components/CorporateNavigation.vue'
    import ResourceEditor from '@Quest/Resources/Components/ResourceEditor.vue'

    import { ResourceEditorViewModel, ResourceEditorFormSubmitEventPayload } from '@Quest/Resources/Components/ResourceEditor'
    import { ResourceReadModel, ResourcesReadModel } from '@Quest/Resources/readmodels'

    import { useResourcesByStrategyIdQueryV1 } from '@Quest/Resources/queries-vue-composables'
    import { useCreateResourceCommandV1, useUpdateResourceCommandV1, useDeleteResourceCommandV1 } from '@Quest/Resources/commands-vue-composables'


    // route
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ResourcesPage',
  setup(__props) {

    const route = useRoute()

    const workspaceId = computed(() => Number(route.params.workspaceId ?? 0))
    const strategyId = computed(() => String(route.params.strategyId ?? ''))


    // query
    const {
        runResourcesByStrategyIdQueryV1,
        modelResourcesByStrategyIdQueryV1
    } = useResourcesByStrategyIdQueryV1(workspaceId, strategyId)

    const rm = modelResourcesByStrategyIdQueryV1 as Ref<ResourcesReadModel | null>


    // commands
    const {
        invokeCreateResourceCommandV1,
        succeedCreateResourceCommandV1
    } = useCreateResourceCommandV1(workspaceId, strategyId)

    const {
        invokeUpdateResourceCommandV1,
        succeedUpdateResourceCommandV1
    } = useUpdateResourceCommandV1(workspaceId, strategyId)

    const {
        invokeDeleteResourceCommandV1,
        succeedDeleteResourceCommandV1
    } = useDeleteResourceCommandV1(workspaceId, strategyId)


    // view model (stable instance)
    const resourceEditor = shallowReactive(new ResourceEditorViewModel())


    // computed
    const resourcesView = computed<ResourceReadModel[]>(() =>
        (rm.value?.Resources ?? []).slice().sort((a, b) =>
            strCompareLowerCase(a.Name, b.Name)
        )
    )


    // methods
    function fmtNum(val: number | null)
    {
        return toStringSmartly(val)
    }

    function showResourceCreator()
    {
        resourceEditor.showCreator()
    }

    function showResourceEditor(r: ResourceReadModel)
    {
        resourceEditor.showEditor(r.Id, r.Name, r.Unit, r.ExpenseClassification)
    }

    function handleResourceEditorFormSubmit(e: ResourceEditorFormSubmitEventPayload)
    {
        if (e.id == null)
        {
            invokeCreateResourceCommandV1({
                id: guid(),
                name: e.name,
                unit: e.unit,
                classification: e.classification,
                costPerUnit: e.costPerUnit
            })
        } else
        {
            invokeUpdateResourceCommandV1({
                id: e.id,
                name: e.name,
                unit: e.unit,
                classification: e.classification
            })
        }
    }

    function handleDeleteResourceCommand(r: ResourceReadModel)
    {
        if (confirm("Are you sure?") === true)
        {
            invokeDeleteResourceCommandV1({
                id: r.Id
            })
        }
    }


    // lifecycle
    onMounted(() =>
    {
        document.title = "Resources | TransparentChoice"
        runResourcesByStrategyIdQueryV1()
    })


    // command success watchers (split by concern)
    watch(succeedCreateResourceCommandV1, (current, previous) =>
    {
        if (current && !previous)
        {
            runResourcesByStrategyIdQueryV1()
            resourceEditor.close()
        }
    })

    watch(succeedUpdateResourceCommandV1, (current, previous) =>
    {
        if (current && !previous)
        {
            runResourcesByStrategyIdQueryV1()
            resourceEditor.close()
        }
    })

    watch(succeedDeleteResourceCommandV1, (current, previous) =>
    {
        if (current && !previous)
        {
            runResourcesByStrategyIdQueryV1()
        }
    })

return (_ctx: any,_cache: any) => {
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(ResourceEditor, {
      viewModel: _unref(resourceEditor),
      onFormSubmit: handleResourceEditorFormSubmit
    }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(CorporateNavigation, { ActivePage: "resources" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", { class: "row" }, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "col-lg-6" }, [
          _createElementVNode("h1", { style: {"font-size":"2em","font-weight":"300","color":"#33475b","margin":"0"} }, "Resources")
        ], -1 /* CACHED */)),
        _createElementVNode("div", { class: "col-lg-6 text-right align-self-end" }, [
          _createElementVNode("button", {
            role: "button",
            class: "btn btn-success",
            style: {"padding":"0.7em 2em"},
            onClick: showResourceCreator
          }, "Create resource")
        ])
      ]),
      _cache[9] || (_cache[9] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 60px"} }, null, -1 /* CACHED */)),
      (_unref(rm))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_4, [
                  _cache[2] || (_cache[2] = _createElementVNode("span", { class: "btn btn-secondary disabled" }, " Resources ", -1 /* CACHED */)),
                  _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_5, [...(_cache[1] || (_cache[1] = [
                    _createTextVNode(" Unit costs ", -1 /* CACHED */)
                  ]))])), [
                    [_directive_sanitizedHref, `/#/enterprise/resource-unit-costs/${workspaceId.value}/${strategyId.value}`]
                  ])
                ])
              ]),
              _cache[3] || (_cache[3] = _createElementVNode("div", null, null, -1 /* CACHED */))
            ]),
            _createElementVNode("table", _hoisted_6, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _cache[4] || (_cache[4] = _createElementVNode("th", null, "Name", -1 /* CACHED */)),
                  _cache[5] || (_cache[5] = _createElementVNode("th", null, "Unit", -1 /* CACHED */)),
                  _createCommentVNode("<th>Capacity</th><th>Allocated</th>"),
                  _cache[6] || (_cache[6] = _createElementVNode("th", null, "P&L", -1 /* CACHED */)),
                  _createElementVNode("th", null, "Cost per unit (" + _toDisplayString(new Date().getFullYear()) + ")", 1 /* TEXT */),
                  _cache[7] || (_cache[7] = _createElementVNode("th", { style: {"width":"120px"} }, null, -1 /* CACHED */))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resourcesView.value, (r) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: r.Id
                  }, [
                    _createElementVNode("td", null, [
                      _withDirectives((_openBlock(), _createElementBlock("a", null, [
                        _createTextVNode(_toDisplayString(r.Name), 1 /* TEXT */)
                      ])), [
                        [_directive_sanitizedHref, `/#/enterprise/resource-capacity/${workspaceId.value}/${strategyId.value}/${r.Id}`]
                      ])
                    ]),
                    _createElementVNode("td", null, _toDisplayString(r.Unit), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(r.ExpenseClassification), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(fmtNum(r.CostPerUnit)) + " " + _toDisplayString(r.Currency), 1 /* TEXT */),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_7, [
                        _cache[8] || (_cache[8] = _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-outline-secondary dropdown-toggle",
                          "data-toggle": "dropdown"
                        }, " Actions ", -1 /* CACHED */)),
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            onClick: ($event: any) => (showResourceEditor(r))
                          }, "Edit", 8 /* PROPS */, _hoisted_9),
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            onClick: ($event: any) => (handleDeleteResourceCommand(r))
                          }, "Delete", 8 /* PROPS */, _hoisted_10)
                        ])
                      ])
                    ])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}
}

})